import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const aikido = defineConnector({
  identifier: "aikido",
  name: "Aikido",
  tagLine: "Application security posture management",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://app\\.aikido\\.dev/api/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create API credentials in Aikido",
      items: [
        {
          kind: "markdown",
          content:
            "Log in to your [Aikido](https://app.aikido.dev/) account and go to [Settings → Integrations → API](https://app.aikido.dev/settings/integrations/api/aikido/rest). Create a new client to generate a client ID (starting with `AIK_CLIENT_`) and client secret (starting with `AIK_SECRET_`). Note that the secret can only be viewed once.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          placeholder: "AIK_CLIENT_…",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          placeholder: "AIK_SECRET_…",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "client_credentials",
    tokenEndpoint: () => "https://app.aikido.dev/api/oauth/token",
    clientCredentialsFrom: "db",
    tokenEndpointAuthMethod: () => "client_secret_basic_no_urlencode",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://app.aikido.dev/api/public/v1/repositories/code",
  },
});
